<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: "Search",
  },
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const isFocused = ref(false);
const onFocus = () => {
  isFocused.value = true;
};
const onBlur = () => {
  isFocused.value = false;
};
</script>

<template>
  <div
    class="relative border rounded flex flex-row items-center box-content text-input-1"
    :class="{
      ' outline outline-2 outline-focus -outline-offset-2': isFocused,
      'border-medium-tint': !isFocused,
    }"
  >
    <div class="flex flex-col items-center justify-center h-[40px] mx-2">
      <BaseIconSearch class="text-medium" />
    </div>

    <BaseTextInput
      class="border-none grow p-2 pl-0"
      :model-value="props.modelValue"
      @update:model-value="emit('update:modelValue', $event)"
      :placeholder="props.placeholder"
      @focus="onFocus"
      @blur="onBlur"
      :block-outline="true"
    />
  </div>
</template>

<style scoped></style>
